import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {endpoint} from "./endpoint";
import Notiflix from "notiflix";

const Payment = ({ total, collectionID,user,bags }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const yoco = new window.YocoSDK({
      publicKey: 'pk_test_ed3c54a6gOol69qa7f45' // Replace with your live public key when in production
    });

    const showPayPopup = (user,bags) => {
      yoco.showPopup({
        amountInCents: total,
        currency: 'ZAR',
        name: 'Pay For Collection',
        description: `Payment for Collection ID: ${collectionID}`,
        callback: function (result) {
          if (result.error) {
            const errorMessage = result.error.message;
            Notiflix.Notify.failure("Error occurred: " + errorMessage);
            navigate("/dashboard"); // Redirect to portal
          } else {
            // Handle successful payment here
            handlePaymentSuccess(result.id,user,bags);
          }
        }
      });
    };

    const handlePaymentSuccess = (token,user,bags) => {
      fetch(`${endpoint}/gymapp/pay.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          total: total,
          collectionID: collectionID,
          token: token,
		  user:user,
		  bags:JSON.stringify(bags)
        }),
      })
        .then((response) => response.text())
        .then((data) => {
          if (data === "true") {
            Notiflix.Report.success("Payment successful!");
            navigate("/dashboard");
          } else {
            Notiflix.Report.failure("Error: " + data);
            navigate("/dashboard");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          navigate("/dashboard");
        });
    };

    showPayPopup(user,bags); // Trigger the payment popup on component load
  }, [total, collectionID, navigate,user,bags]);

  return null; // No UI needed as the payment popup will be handled by YOCO
};

export default Payment;
